import styled from 'styled-components';

export const Container = styled.div`
  padding: 15px;
  border-radius: 5px;
  max-height: 65vh;
  font-family: 'Graphik Medium', 'Graphik', sans-serif;
  font-size: 14px;
`;

export const Message = styled.div`
  color: #003D50;
  letter-spacing: 0;
  line-height: 22px;
  padding-bottom: 15px;
`;

export const CheckboxWrapper = styled.div`
  padding: 10px;
  border-radius: 5px;
  background-color: #F9ECC8;
`;

export const Checkbox = styled.input`
  margin: 4px 0 0;
  margin-top: 1px;
  line-height: normal;
`;

export const CheckboxText = styled.span`
  color: #003D50;
  letter-spacing: 0;
  line-height: 15px;
  padding-left: 15px;
`;

export const SubmitButtonWrapper = styled.div`
  height: 80px;
  margin: 0px;
  padding-top: 30px;
  padding-bottom: 0px;
`;

export const SubmitButton = styled.button`
  height: 36px;
  width: 94px;
  display: inline-block;
  padding: 8px 7px 6px 7px;
  margin: 20px 0px 0px;
  background-color: #20907F;
  text-decoration: none;
  color: #ffffff;
  border-radius: 50px;
  font-size: 16px;
  font-weight: normal;
  letter-spacing: 0;
  line-height: 19px;
  text-align: center;
  border: none;
  cursor: pointer;
`;
